import { UW_PERIL_NOTES } from "@covertree/consts";
import {
  CoverageELiability,
  CoverageFMedicalPaymentToOthers,
  CoverageWithSettlementOption,
  UnitLevelCoverages,
} from "@covertree/new-business-graphql";
import {
  mapDollarsEnumToNumber,
  mapSettlementOptionToDisplayValue,
} from "@covertree/new-business-mappings";

type GetItems<ArgType> = (
  arg: ArgType,
  unitLevelCoverages?: UnitLevelCoverages
) => Record<string, string>[];

const getCoverageWithSettlementItems: GetItems<CoverageWithSettlementOption> = (
  coverageData
) => [
  {
    name: mapSettlementOptionToDisplayValue(coverageData.settlementOption),
  },
];

const getMedicalPaymentsItems: GetItems<CoverageFMedicalPaymentToOthers> = (
  coverageData
) => {
  if (!coverageData.value) {
    return [];
  }

  const coverageFMedicalPaymentToOthersNumberValue = Number(
    mapDollarsEnumToNumber(coverageData.value)
  );

  if (isNaN(coverageFMedicalPaymentToOthersNumberValue)) {
    return [
      {
        name: "Per Person",
      },
      {
        name: "Per Incident",
      },
    ];
  }

  const [perPerson, perIncident] =
    coverageData.valueCustomization?.options
      .find(({ value }) => value === coverageFMedicalPaymentToOthersNumberValue)
      ?.label.split("/") ?? [];

  return [
    {
      name: "Per Person",
      value: perPerson,
    },
    {
      name: "Per Incident",
      value: perIncident,
    },
  ];
};

const getPersonalLiabilityItems: GetItems<CoverageELiability> = (
  coverageData,
  unitLevelCoverages
) => {
  if (!coverageData?.value) {
    return [];
  }

  const {
    divingBoardSlideLiabilityExtension,
    trampolineLiabilityExtension,
    animalLiability,
  } = unitLevelCoverages || {};

  return [
    ...(divingBoardSlideLiabilityExtension?.value
      ? [
          {
            name: UW_PERIL_NOTES.divingBoardSlideLiability,
          },
        ]
      : []),
    ...(trampolineLiabilityExtension?.value
      ? [
          {
            name: UW_PERIL_NOTES.trampolineLiability,
          },
        ]
      : []),
    ...(animalLiability?.value === "Excluded"
      ? [
          {
            name: UW_PERIL_NOTES.animalLiabilityExclusion,
          },
        ]
      : []),
  ];
};

const getPremisesLiabilityItems: GetItems<CoverageELiability> = (
  coverageData,
  unitLevelCoverages
) => {
  if (!coverageData?.value) {
    return [];
  }

  const { divingBoardSlideLiabilityExtension, trampolineLiabilityExtension } =
    unitLevelCoverages || {};

  return [
    ...(divingBoardSlideLiabilityExtension?.value
      ? [
          {
            name: UW_PERIL_NOTES.divingBoardSlideLiability,
          },
        ]
      : []),
    ...(trampolineLiabilityExtension?.value
      ? [
          {
            name: UW_PERIL_NOTES.trampolineLiability,
          },
        ]
      : []),
  ];
};

export {
  getCoverageWithSettlementItems,
  getMedicalPaymentsItems,
  getPersonalLiabilityItems,
  getPremisesLiabilityItems,
};
